export const RECEIVE_AGENTS = 'RECEIVE_AGENTS';
export const RECEIVE_AGENT = 'RECEIVE_AGENT';
export const ERROR = 'ERROR';
